<template>
  <div>
    <div class="row m-2">
      <div class="col-sm-12 m-2 text-center">
        <h3>ویرایش اطلاعات شرکت برای پرینت</h3>
      </div>
      <div class="col-sm-3  m-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام شرکت</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="company.companyName"
            type="text"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-12 m-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>هدر 1</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="company.header1"
            type="text"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-12 m-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>هدر 2</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="company.header2"
            type="text"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-12 m-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>هدر 3</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="company.header3"
            type="text"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-12 m-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>فوتر 1</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="company.footer1"
            type="text"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-12 m-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>فوتر 2</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="company.footer2"
            type="text"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-12 m-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>فوتر 3</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="company.footer3"
            type="text"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-12 m-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>پرینت 1</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="company.print1"
            type="text"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-12 m-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>پرینت 2</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="company.print2"
            type="text"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-12 m-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>پرینت 3</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="company.print3"
            type="text"
            class="form-control"
          >
        </div>
      </div>
      <div class="input-group col-sm-12 m-2">
        <div class="w-100">
          <div>
            <button class="btn btn-secondary w-100" @click="saveModal()">
              ذخیره اطلاعات
            </button>
          </div>
        </div>

      </div>
    </div>
    <hr/>
    <div class="row m-2">
      <div class="col-sm-12 m-2 text-center">
        <h4 class="d-lg-inline-flex">انتخاب مشخصه ها برای نمایش عنوان 1</h4>&nbsp;
        <span>این عنوان برای اسناد داخلی استفاده میشود</span>
      </div>
      <div class="col-sm-12 m-2 text-center">
        <h6>پیش نمایش عنوان 1</h6>
        <span v-if="title1Settings1.st1Selected">کد محصول </span>
        <span v-if="title1Settings1.st2Selected"> نام محصول </span>
        <span v-if="title1Settings1.st3Selected">نام استاندارد </span>
        <span v-if="title1Settings1.st4Selected">نام استاندارد2 </span>
        <span v-if="title1Settings1.st5Selected">نام فاکتور مشتری </span>
        <span v-if="title1Settings1.st6Selected">کد فنی </span>
        <span v-if="title1Settings1.st7Selected">رنگ </span>
        <span v-if="title1Settings1.st8Selected">ضخامت میلیمتر </span>
        <span v-if="title1Settings1.st9Selected">وزن کیلوگرم</span>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>کد محصول</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings1.st1Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام محصول</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings1.st2Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام استاندارد</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings1.st3Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام استاندارد 2</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings1.st4Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام فاکتور مشتری</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings1.st5Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>کد فنی</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings1.st6Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>رنگ</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings1.st7Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>ضخامت</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings1.st8Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>وزن</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings1.st9Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="input-group col-sm-12 m-2">
        <div class="w-100">
          <div>
            <button class="btn btn-secondary w-100" @click="saveModalTite1(1)">
              ذخیره اطلاعات
            </button>
          </div>
        </div>
      </div>
    </div>
    <hr/>
    <div class="row m-2">
      <div class="col-sm-12 m-2 text-center">
        <h4 class="d-lg-inline-flex">انتخاب مشخصه ها برای نمایش عنوان 2</h4>&nbsp;
        <span>این عنوان برای اسناد خارج از شرکت استفاده میشود</span>
      </div>
      <div class="col-sm-12 m-2 text-center">
        <h6>پیش نمایش عنوان 2</h6>
        <span v-if="title1Settings2.st1Selected">کد محصول </span>
        <span v-if="title1Settings2.st2Selected"> نام محصول </span>
        <span v-if="title1Settings2.st3Selected">نام استاندارد </span>
        <span v-if="title1Settings2.st4Selected">نام استاندارد2 </span>
        <span v-if="title1Settings2.st5Selected">نام فاکتور مشتری </span>
        <span v-if="title1Settings2.st6Selected">کد فنی </span>
        <span v-if="title1Settings2.st7Selected">رنگ </span>
        <span v-if="title1Settings2.st8Selected">ضخامت میلیمتر </span>
        <span v-if="title1Settings2.st9Selected">وزن کیلوگرم </span>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>کد محصول</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings2.st1Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام محصول</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings2.st2Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام استاندارد</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings2.st3Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام استاندارد 2</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings2.st4Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام فاکتور مشتری</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings2.st5Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>کد فنی</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings2.st6Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>رنگ</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings2.st7Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>ضخامت</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings2.st8Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>وزن</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings2.st9Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="input-group col-sm-12 m-2">
        <div class="w-100">
          <div>
            <button class="btn btn-secondary w-100" @click="saveModalTite1(2)">
              ذخیره اطلاعات
            </button>
          </div>
        </div>
      </div>
    </div>
    <hr/>
    <div class="row m-2">
      <div class="col-sm-12 m-2 text-center">
        <h4 class="d-lg-inline-flex">انتخاب مشخصه ها برای نمایش عنوان 3</h4>&nbsp;
        <span>این عنوان برای دستور کارها و برنامه ریزی داخل شرکت استفاده میشود</span>
      </div>
      <div class="col-sm-12 m-2 text-center">
        <h6>پیش نمایش عنوان 3</h6>
        <span v-if="title1Settings3.st1Selected">کد محصول </span>
        <span v-if="title1Settings3.st2Selected"> نام محصول </span>
        <span v-if="title1Settings3.st3Selected">نام استاندارد </span>
        <span v-if="title1Settings3.st4Selected">نام استاندارد2 </span>
        <span v-if="title1Settings3.st5Selected">نام فاکتور مشتری </span>
        <span v-if="title1Settings3.st6Selected">کد فنی </span>
        <span v-if="title1Settings3.st7Selected">رنگ </span>
        <span v-if="title1Settings3.st8Selected">ضخامت میلیمتر </span>
        <span v-if="title1Settings3.st9Selected">وزن کیلوگرم </span>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>کد محصول</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings3.st1Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام محصول</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings3.st2Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام استاندارد</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings3.st3Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام استاندارد 2</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings3.st4Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام فاکتور مشتری</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings3.st5Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>کد فنی</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings3.st6Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>رنگ</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings3.st7Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>ضخامت</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings3.st8Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-sm-2 m-1">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>وزن</span>
            </div>
          </div>
          <input
            ref="server"
            v-model="title1Settings3.st9Selected"
            type="checkbox"
            class="form-control"
          >
        </div>
      </div>
      <div class="input-group col-sm-12 m-2">
        <div class="w-100">
          <div>
            <button class="btn btn-secondary w-100" @click="saveModalTite1(3)">
              ذخیره اطلاعات
            </button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import BaseService from "../_framework/api/BaseService";

  export default {
    name: "companySetting",
    components: {},
    data() {
      return {
          newlogoCliked1:false,
        newlogoCliked2: false,
        newlogoCliked3: false,
        company: {
          companyName: "",
          companyLogo1: "",
          companyLogo2: "",
          companyLogo3: "",
          header1: "",
          header2: "",
          header3: "",
          footer1: "",
          footer2: "",
          footer3: "",
          print1: "",
          print2: "",
          print3: "",
          title1: "",
          title2: "",
          title3: "",
        },
        title1Settings1: {
          st1Selected: false,
          st2Selected: false,
          st3Selected: false,
          st4Selected: false,
          st5Selected: false,
          st6Selected: false,
          st7Selected: false,
          st8Selected: false,
          st9Selected: false,

        },
        title1Settings2: {
          st1Selected: false,
          st2Selected: false,
          st3Selected: false,
          st4Selected: false,
          st5Selected: false,
          st6Selected: false,
          st7Selected: false,
          st8Selected: false,
          st9Selected: false,

        },
        title1Settings3: {
          st1Selected: false,
          st2Selected: false,
          st3Selected: false,
          st4Selected: false,
          st5Selected: false,
          st6Selected: false,
          st7Selected: false,
          st8Selected: false,
          st9Selected: false,

        },
      };
    },
    beforeMount() {
      this.getModel();

    },
    methods: {
      getModel() {
        new BaseService("company/CompanySettingGet").getList().then(rs => {
          this.company = rs.data.company;
          this.title1Settings1 = rs.data.title1Settings1;
          this.title1Settings2 = rs.data.title1Settings2;
          this.title1Settings3 = rs.data.title1Settings3;
        }).catch((error) => {
        });

      },
      saveModal() {
        new BaseService("company/UpdateCompanySetting").update(this.company).then(rs => {
          this.$noty.success("تغییرات با موفقیت ثبت شد");
          this.getModel();
        }).catch((error) => {
          this.$noty.error("متاسفانه خطایی رخ داده");
        });
      },
      saveModalTite1(num) {
        switch (num) {
          case 1:
            new BaseService("company/UpdateTitle1Settings").update(this.title1Settings1).then(rs => {
              this.$noty.success("تغییرات با موفقیت ثبت شد");
              this.getModel();
            }).catch((error) => {
              this.$noty.error("متاسفانه خطایی رخ داده");
            });
            break;
          case 2:
            new BaseService("company/UpdateTitle2Settings").update(this.title1Settings2).then(rs => {
              this.$noty.success("تغییرات با موفقیت ثبت شد");
              this.getModel();
            }).catch((error) => {
              this.$noty.error("متاسفانه خطایی رخ داده");
            });
            break;
          case 3:
            new BaseService("company/UpdateTitle3Settings").update(this.title1Settings3).then(rs => {
              this.$noty.success("تغییرات با موفقیت ثبت شد");
              this.getModel();
            }).catch((error) => {
              this.$noty.error("متاسفانه خطایی رخ داده");
            });
            break;

        }

      },

    },
  };
</script>
